const timeRangeDefaults = [
  {
    id: 'pastWeek',
    name: 'Past Week',
  },
  {
    id: 'pastMonth',
    name: 'Past Month',
  },
  {
    id: 'pastYear',
    name: 'Past Year',
  },
  {
    id: 'thisWeek',
    name: 'This Week',
  },
  {
    id: 'thisMonth',
    name: 'This Month',
  },
  {
    id: 'thisYear',
    name: 'This Year',
  },
]

export default timeRangeDefaults
